import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import CustomerForm from "../CustomerForm";
import Dropzone from "react-dropzone";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { Controller, useForm } from "react-hook-form";
import LaiPhang from "./LaiPhang";
import DuNoGiamDan, { layKieuLaiSuatDuNoGoc } from "./DuNoGiamDan";
import choVayConst from "constants/choVayConst";
import NumberInput from "components/GenericComponent/NumberInput";
import NumberFormat from "react-number-format";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import UploadMultiFile from "components/GenericComponent/UploadMultiFile";
import UploadMultiFile1 from "components/GenericComponent/UploadMultiFile1";
import ListTaiSanForm from "../ListTaiSanForm";
import { convertToNumber } from "utils/numberExtension";
import TraGopApi from "service/traGopApi";
import TaiSanApi from "service/taiSanApi";
import CauHinhApi from "../../../service/cauHinhApi";
import configsRole from "utils/configsRole";
import ChoVayApi from "../../../service/choVayApi";
import TextInputTwoRow from "components/GenericComponent/TextInputTwoRow";
import UserApi from "../../../service/userApi";
import { getUserLogin } from "utils/user";
import { formatNumber, formatMoney } from "utils/currencyFormat";
import cauHinh from "utils/cauHinh";
import TatToanChoDuyetApi from "../../../service/tatToanChoDuyetApi";
import DanhDachIcloudApi from "../../../service/QuanTriHeThong/DanhDachIcloudApi";
import { pushNotification } from "utils/notifications";
import ThemMoiLoaiTaiSanContainer from "containers/Common/TaiSan/ThemMoiLoaiTaiSanContainer";
import {
  convertDate,
  addOneMonthKeepDay,
  addOneMonthKeepDay1,
} from "utils/formatDate";
import KySoAPI from "service/In/KySoAPI";
import CamDoApi from "service/camDoApi";
import useHinhThucThanhToan from "utils/useHinhThucThanhToan";
import ThuocTinhThongKeHopDong from "../ThuocTinhThongKeHopDong";

const ThemMoiTraGop = (props) => {
  let {
    show,
    customer,
    getAutocompleteCustomer,
    user,
    phikhac,
    phikhachangky,
    thuoctinhtaisan,
    store,
    nguonkhachhang,
    postTraGop,
    onHide,
    cauhinh,
    getDetailCustomer,
    themmoitragop,
    loaitaisan,
    setChoVayEdit,
    setTaiSanTraGop,
    phanquyen,
    showModalLoaiTaiSan,
    getComboLoaiTaiSan,
    getThuocTinhTaiSan,
    getThuocTinhTaiSan1,
    getComboStore,
    inHopDong,
    inPhieuThu,
    checkEditCustomer,
    setEnableEditCustomer,
    getDetailCustomerSuccess,
    quanlycuahang,
    setIsTraGopReturn,
    SuDungPhiPhat_DongLai_TatToan,
    SuDungPhiPhat_DongLai_Cham,
    SuDungCongTacVienNhanVien,
    SuDungTatToanSom,
  } = props;
  let { comboNguonKhachHang } = nguonkhachhang;
  let { objThuocTinhTaiSan, objThuocTinhTaiSan1, thuocTinhTaiSanLoaded } =
    thuoctinhtaisan || {};
  let { objComboStore } = store || {};
  let { comboLoaiTaiSan, comboLoaiTaiSanLoaded, isShowModalLoaiTaiSan } =
    loaitaisan || {};
  let ListLoaiTaiSan = comboLoaiTaiSan || [];
  let {
    ConfigTMTG,
    choVayEdit,
    setListPhiKhac,
    postTraGopLoading,
    postTraGopReturn,
    TaiSanTraGop,
    isShowFormTraGop,
  } = themmoitragop;
  let NoteTaiSan = TaiSanTraGop.Note;
  let AnhTaiSan = TaiSanTraGop.AnhTaiSan;
  let { CategoryId, TenTaiSan, StoreID, PhiKho, LoaiTaiSan } = TaiSanTraGop;
  let MaTaiSan = TaiSanTraGop.Code || TaiSanTraGop.MaTaiSan;
  let { objConfig } = cauhinh;
  let ConfigPhiKho = objConfig.PhiKho;
  let objConfigSysLoaiTS = ConfigTMTG;
  let {
    LaiSuat,
    TypePaid,
    ChoVayId,
    CountTypePaid,
    BeforeAfter,
    NgayVay,
    KieuLaiSuat,
    Sotienvay,
    SoLanTra,
    SoNgayToiThieu,
    SoNgayGiaHan,
    CustomerID,
    Note,
    NgayTra,
    TongNgayVay,
    IsCopy,
    showButtonIn,
    showButtonInPhieuThu,
    ThuChiId,
    IsEditChoVay,
    IsEditCustomer,
    Code,
    IsDuNoGiamDan,
    ValueLai,
    LinkDinhKem,
    StatusPaidHo,
    PhiPhatTraLai,
    LoaiPhiPhatTraLai,
    PhiPhatTatToan,
    LoaiPhiPhatTatToan,
    PhiDongLaiCham,
    SoTienThuKyDau,
    MaNhanVien,
    TypeDuNo,
  } = choVayEdit;

  IsEditChoVay = !IsEditChoVay;
  if (choVayEdit.IsCopy) IsEditChoVay = false;
  const selectedTypeDuNo = TypeDuNo ? parseInt(TypeDuNo, 10) : 1;
  const [isDuNoGiamDan, setIsDuNoGiamDan] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  const [imgCusOld, setImgCusOld] = useState("");
  const [isSetPhiKhac, setIsSetPhiKhac] = useState(null);
  const [isSetPhiKhacHangKy, setIsSetPhiKhacHangKy] = useState(null);
  const [imageTaiSans, setImageTaiSans] = useState([]);
  const [anhTaiSan, setAnhTaiSan] = useState([]);
  const [fileDinhKems, setFileDinhKems] = useState([]);
  const [linkDinhKem, setLinkDinhKem] = useState("");
  const [curentNoteTaiSan, setCurentNoteTaiSan] = useState("");
  const [ThuocTinhTaiSan, setThuocTinhTaiSan] = useState([]);
  const [ListTaiSanCamCo, setListTaiSanCamCo] = useState([]);
  const [showAddNewTaiSan, setShowAddNewTaiSan] = useState(false);
  const [currentChoVay, setCurrentChoVay] = useState({});
  const [currentCode, setCode] = useState(null);
  const [ChonLoaiPhiKhac, setChonLoaiPhiKhac] = useState(false);
  const [ChonLoaiPhiKhacHangKy, setChonLoaiPhiKhacHangKy] = useState(false);
  const [intLoaiPhiPhatTraLai, setLoaiPhiPhatTraLai] = useState(1);
  const [intCauHinhLai, setCauHinhLai] = useState(1);
  const [intLoaiPhiPhatTatToan, setLoaiPhiPhatTatToan] = useState(1);
  const [CanhBaoSoHopDong, setCanhBaoSoHopDong] = useState("");
  const [listNhanVien, setListNhanVien] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [thamDinhHanMuc, setThamDinhHanMuc] = useState(0);
  const [tragop_inchoduyet, setInChoDuyet] = useState(false);
  const [tragop_duyettheolichsuvay, setDuyetLichSu] = useState(false);
  const [tragop_duyettheohanmucgoi, setDuyetHanMucGoi] = useState(false);
  const [tragop_duyettheohanmucchophep, setDuyetHanMucChoPhep] =
    useState(false);
  const [isCauHinhQuyTrinhPheDuyet, setIsCauHinhQuyTrinhPheDuyet] =
    useState(false);
  const [isCauHinhT77, setisCauHinhT77] = useState(false);
  const [isDuNoGocCoDinh, setDuNoGocCoDinh] = useState(false);
  const [isCauHinhKhachHangBinhAn, setCauHinhKhachHangBinhAn] = useState(false);
  const [isShopadmin, setisShopadmin] = useState(false);
  const [HasTatToanChoDuyet, setHasTatToanChoDuyet] = useState(0);
  const [dataTaiSanIcloudChon, setDataTaiSanIcloudChon] = useState({});
  const [isCauHinhTaiKhoanIcloud, setIsCauHinhTaiKhoanIcloud] = useState(false);
  //Cấu hình ChiPhiVayTraGop: 1 = chi phí vay tính theo % Ngày, 3 = theo % Tháng.
  //(Giá trị 0 là dữ liệu cũ trước khi đổi mã, vẫn được hiểu là % Tháng.)
  //Mặc định 1 cho khớp giá trị mặc định phía backend khi công ty chưa có bản ghi cấu hình.
  const [chiPhiVayTheoNgay, setChiPhiVayTheoNgay] = useState(true);
  //Hợp đồng đã tồn tại: đơn vị chi phí vay lấy theo KieuLaiSuat đã lưu trên hợp đồng
  //(null hoặc 1 = % Ngày, 3 = % Tháng) chứ không theo cấu hình hệ thống hiện tại,
  //vì cấu hình có thể đã bị đổi sau khi hợp đồng được tạo.
  //Thêm mới thì vẫn theo cấu hình ChiPhiVayTraGop.
  const chiPhiVayTheoNgayHienThi =
    ChoVayId > 0
      ? KieuLaiSuat == null || Number(KieuLaiSuat) === 1
      : chiPhiVayTheoNgay;
  const [isMoney88, setIsMoney88] = useState(false);
  let currentForm = useForm({
    CountTypePaid: CountTypePaid,
    Sotienvay: Sotienvay,
    SoLanTra: SoLanTra,
    SoNgayToiThieu: SoNgayToiThieu,
    SoNgayGiaHan: SoNgayGiaHan,
    NoteTaiSan: NoteTaiSan,
    Code: Code,
  });
  const { register, handleSubmit, errors, control, setValue } = currentForm; // initialize the hook
  let { objListPhiKhac } = phikhac;
  let { objListPhiKhacHangKy } = phikhachangky;
  let { thongTinCuaHang } = quanlycuahang ? quanlycuahang : {};

  const [cauHinhThuKyDau, setCauHinhThuKyDau] = useState(false);
  const [HasKySo, setHasKySo] = useState(0);
  const batHinhThucThanhToan = useHinhThucThanhToan();
  const [hinhThucThanhToan, setHinhThucThanhToan] = useState(0);
  useEffect(() => {
    if (!batHinhThucThanhToan || !choVayEdit.ChoVayId) return;
    let daHuy = false;
    CamDoApi.hinhThucThanhToanHopDong(choVayEdit.ChoVayId).then((response) => {
      if (!daHuy && response.status === 200 && response.data)
        setHinhThucThanhToan(response.data.HinhThucThanhToan || 0);
    });
    return () => {
      daHuy = true;
    };
  }, [batHinhThucThanhToan, choVayEdit.ChoVayId]);
  let {
    _anDinhNgayThangTraGop,
    _allBeforeAfterTraGop,
    _allTraThieuTraDuTraGop,
    _allKyGopTraGop,
    HoaHongTraGop,
    _IsMacDinh1ThangAnDinhTraGop,
  } = ConfigTMTG ? ConfigTMTG : {};

  useEffect(() => {
    if (choVayEdit.IsDuNoGiamDan !== undefined) {
      setIsDuNoGiamDan(choVayEdit.IsDuNoGiamDan);
    }
    if (choVayEdit.ChoVayId > 0) {
      kiemTraHopDongChoVayTatToanChoDuyet(choVayEdit.ChoVayId);
      GetTaiKhoanIcloudLienKetByMaHopDong(choVayEdit.Code);
      KySoAPI.kiemTraHopDongChoVayKySo(choVayEdit.ChoVayId);
    }
    UserApi.checkRole("shopadmin").then((response) => {
      setisShopadmin(response.data);
    });
    CauHinhApi.getConfigSys1().then((response) => {
      console.log(IsCopy, "IsCopy");
      if (response.status === 200) {
        if (response.data.length > 0) {
          const isShowThuKyDau = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              configsRole.sConfig.isSoTienThuDauKy.toUpperCase(),
          );
          if (
            typeof isShowThuKyDau !== "undefined" &&
            isShowThuKyDau !== null
          ) {
            if (isShowThuKyDau.valueConfig === "1") {
              setCauHinhThuKyDau(true);
            }
          }

          const configChiPhiVayTraGop = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.ChiPhiVayTraGop.toUpperCase(),
          );
          if (configChiPhiVayTraGop != null) {
            //Chỉ giá trị "1" là % Ngày, còn lại ("3" mới, "0" cũ) là % Tháng.
            setChiPhiVayTheoNgay(configChiPhiVayTraGop.valueConfig === "1");
          }

          const isCauHinhPheDuyet = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsQuyTrinhPheDuyet.toUpperCase(),
          );
          if (isCauHinhPheDuyet != null) {
            if (isCauHinhPheDuyet.valueConfig === "1") {
              setIsCauHinhQuyTrinhPheDuyet(true);
            }
          }

          const configCauHinhT77 = response.data.find(
            (e) =>
              e.keyConfig &&
              e.keyConfig.toUpperCase() ===
                cauHinh.sKey.IsCauHinhT77.toUpperCase(),
          );
          setisCauHinhT77(
            configCauHinhT77 != null && configCauHinhT77.valueConfig === "1",
          );

          const configDuNoGocCoDinh = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.DuNoGiamDanLaiGiamDan.toUpperCase(),
          );
          setDuNoGocCoDinh(
            configDuNoGocCoDinh != null &&
              configDuNoGocCoDinh.valueConfig === "1",
          );

          var username = getUserLogin().UserName;
          var configKey = "TraGop_ChoDuyetTheoHanMuc_HanMuc_" + username;
          const configHanMucCamDo = response.data.find(
            (e) => e.keyConfig.toUpperCase() === configKey.toUpperCase(),
          );
          if (
            typeof configHanMucCamDo !== "undefined" &&
            configHanMucCamDo !== null
          ) {
            setThamDinhHanMuc(
              parseFloat(
                formatMoney(configHanMucCamDo.valueConfig).replaceAll(",", ""),
              ),
            );
          }
          configKey = "TraGop_InChoDuyet_" + username;
          const configRoleInChoDuyet = response.data.find(
            (e) => e.keyConfig.toUpperCase() === configKey.toUpperCase(),
          );
          if (
            typeof configRoleInChoDuyet !== "undefined" &&
            configRoleInChoDuyet !== null &&
            configRoleInChoDuyet.valueConfig === "1"
          ) {
            setInChoDuyet(true);
          }
          configKey = "TraGop_ChoDuyetTheoLichSu_" + username;
          const configRoleDuyetLichSuVay = response.data.find(
            (e) => e.keyConfig.toUpperCase() === configKey.toUpperCase(),
          );
          if (
            typeof configRoleDuyetLichSuVay !== "undefined" &&
            configRoleDuyetLichSuVay !== null &&
            configRoleDuyetLichSuVay.valueConfig === "1"
          ) {
            setDuyetLichSu(true);
          }
          configKey = "TraGop_ChoDuyetTheoHanMucGoiVay_" + username;
          const configRoleDuyetHanMucGoi = response.data.find(
            (e) => e.keyConfig.toUpperCase() === configKey.toUpperCase(),
          );
          if (
            typeof configRoleDuyetHanMucGoi !== "undefined" &&
            configRoleDuyetHanMucGoi !== null &&
            configRoleDuyetHanMucGoi.valueConfig === "1"
          ) {
            setDuyetHanMucGoi(true);
          }
          configKey = "TraGop_ChoDuyetTheoHanMuc_" + username;
          const configRoleDuyetHanMuc = response.data.find(
            (e) => e.keyConfig.toUpperCase() === configKey.toUpperCase(),
          );
          if (
            typeof configRoleDuyetHanMuc !== "undefined" &&
            configRoleDuyetHanMuc !== null &&
            configRoleDuyetHanMuc.valueConfig === "1"
          ) {
            setDuyetHanMucChoPhep(true);
          }
          const isCauHinhTaiKHoanIcloud = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsTaiKhoanIcloud.toUpperCase(),
          );
          if (isCauHinhTaiKHoanIcloud != null) {
            if (isCauHinhTaiKHoanIcloud.valueConfig === "1") {
              setIsCauHinhTaiKhoanIcloud(true);
            }
          }

          const configMoney88 = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsMoney88.toUpperCase(),
          );
          if (configMoney88 != null) {
            if (configMoney88.valueConfig === "1") {
              setIsMoney88(true);
            }
          }

          const configNangCapKhachHangBinhAn = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsNangCapKHBinhAn.toUpperCase(),
          );
          if (configNangCapKhachHangBinhAn != null) {
            if (configNangCapKhachHangBinhAn.valueConfig === "1") {
              setCauHinhKhachHangBinhAn(true);
            }
          }
        }
      }
    });
    if (choVayEdit.ChoVayId == undefined || choVayEdit.ChoVayId == 0) {
      if (!isLoaded) {
        CauHinhApi.getTimeServer().then((response) => {
          if (response.status === 200) {
            choVayEdit.NgayVay = convertDate(response.data.result);
            if (_anDinhNgayThangTraGop) {
              if (_IsMacDinh1ThangAnDinhTraGop) {
                choVayEdit.NgayThanhToan = convertDate(
                  addOneMonthKeepDay(response.data.result),
                );
              } else {
                choVayEdit.NgayThanhToan = choVayEdit.NgayVay;
              }
            }
          }
        });
      }

      choVayEdit.LoaiPhiPhatTraLai = intLoaiPhiPhatTraLai;
      choVayEdit.LoaiPhiPhatTatToan = intLoaiPhiPhatTatToan;
      ChoVayApi.canhbaoSoLuongHopDong().then((response) => {
        if (response.status === 200 && response.data != "") {
          setCanhBaoSoHopDong(response.data);
        }
      });
    } else if (choVayEdit.ChoVayId > 0) {
      setLoaiPhiPhatTraLai(choVayEdit.LoaiPhiPhatTraLai);
      setLoaiPhiPhatTatToan(choVayEdit.LoaiPhiPhatTatToan);
    }

    if (currentChoVay.CountTypePaid !== CountTypePaid) {
      setValue("CountTypePaid", CountTypePaid);
      currentChoVay.CountTypePaid = CountTypePaid;
    }
    if (currentChoVay.TypePaid !== TypePaid) {
      setValue("TypePaid", TypePaid);
      currentChoVay.TypePaid = TypePaid;
    }
    if (currentChoVay.ValueLai !== ValueLai) {
      setValue("ValueLai", ValueLai);
      currentChoVay.ValueLai = ValueLai;
    }
    if (
      currentChoVay.CountTypePaid !== CountTypePaid ||
      currentChoVay.TypePaid !== TypePaid
    )
      setCurrentChoVay(currentChoVay);
    if (
      (Code && Code !== currentCode) ||
      (showButtonIn && currentCode === null)
    ) {
      setValue("Code", Code);
      setCode(Code);
    }

    if (AnhTaiSan && AnhTaiSan !== anhTaiSan) {
      setAnhTaiSan(AnhTaiSan);
      setImageTaiSans(AnhTaiSan.split(";"));
    }
    //Không chặn theo giá trị cũ: lần chạy đầu (chưa có dữ liệu tài sản) sẽ set về rỗng,
    //nếu chặn thì khi dữ liệu về sau đó sẽ không đổ được vào ô nữa (edit không load lên).
    if (curentNoteTaiSan !== NoteTaiSan) {
      setCurentNoteTaiSan(NoteTaiSan);
      setValue("NoteTaiSan", NoteTaiSan || "");
    }
    if (linkDinhKem != LinkDinhKem) {
      setFileDinhKems(LinkDinhKem ? LinkDinhKem.split(";") : []);
      setLinkDinhKem(LinkDinhKem);
    }
    setIsLoaded(true);
  }, [
    comboLoaiTaiSanLoaded,
    currentChoVay,
    CountTypePaid,
    LaiSuat,
    TypePaid,
    KieuLaiSuat,
    Code,
    currentCode,
    showButtonIn,
    isSetPhiKhac,
    objListPhiKhac,
    AnhTaiSan,
    anhTaiSan,
    curentNoteTaiSan,
    NoteTaiSan,
    setValue,
    ValueLai,
    errors,
    IsDuNoGiamDan,
  ]);

  useEffect(() => {
    if (!isCauHinhT77) return;
    if (!comboLoaiTaiSanLoaded || ListLoaiTaiSan.length === 0) {
      getComboLoaiTaiSan({ trangThai: "" });
    }
    getComboStore();
  }, [isCauHinhT77, comboLoaiTaiSanLoaded, ListLoaiTaiSan.length]);

  useEffect(() => {
    if (
      TaiSanTraGop.ThuocTinhTaiSan &&
      TaiSanTraGop.ThuocTinhTaiSan.length > 0
    ) {
      setThuocTinhTaiSan(TaiSanTraGop.ThuocTinhTaiSan);
    } else {
      setThuocTinhTaiSan(objThuocTinhTaiSan1 || []);
    }
  }, [objThuocTinhTaiSan1, TaiSanTraGop.ThuocTinhTaiSan]);

  useEffect(() => {
    if (
      isCauHinhT77 &&
      ListLoaiTaiSan.length > 0 &&
      (LoaiTaiSan === null ||
        typeof LoaiTaiSan === "undefined" ||
        LoaiTaiSan === "")
    ) {
      const defaultLoaiTaiSan = ListLoaiTaiSan[0].value;
      setTaiSanTraGop({
        ...TaiSanTraGop,
        LoaiTaiSan: defaultLoaiTaiSan,
      });
      getThuocTinhTaiSan1({ loaiTaiSan: defaultLoaiTaiSan });
    }
  }, [isCauHinhT77, ListLoaiTaiSan.length, LoaiTaiSan]);

  useEffect(() => {
    if (
      isCauHinhT77 &&
      objComboStore &&
      objComboStore.length > 0 &&
      (StoreID === null || typeof StoreID === "undefined" || StoreID === "")
    ) {
      setTaiSanTraGop({
        ...TaiSanTraGop,
        StoreID: objComboStore[0].value,
      });
    }
  }, [isCauHinhT77, objComboStore, StoreID]);

  const setAttTaiSan = (field) => (evt) => {
    setTaiSanTraGop({
      ...TaiSanTraGop,
      [field]: evt.target.value,
    });
  };

  const onChangeLoaiTaiSan = (evt) => {
    let loaiTaiSan = evt.target.value;
    setThuocTinhTaiSan([]);
    setTaiSanTraGop({
      ...TaiSanTraGop,
      LoaiTaiSan: loaiTaiSan,
      ThuocTinhTaiSan: [],
    });
    getThuocTinhTaiSan1({ loaiTaiSan });
  };

  const onChangeThuocTinhTaiSan = (index) => (evt) => {
    let listThuocTinh = ThuocTinhTaiSan.slice();
    listThuocTinh[index].OptionValue = evt.target.value;
    setThuocTinhTaiSan(listThuocTinh);
  };

  const onChangeListTaiSan = (listTaiSan) => {
    setListTaiSanCamCo(listTaiSan.slice());
  };

  const onClickShowAddNewTaiSan = () => {
    setShowAddNewTaiSan(!showAddNewTaiSan);
  };

  const hideModalLoaiTaiSan = () => {
    showModalLoaiTaiSan(false);
  };

  const kiemTraHopDongChoVayTatToanChoDuyet = (ChoVayId) => {
    TatToanChoDuyetApi.kiemTraHopDongChoVayTatToanChoDuyet(ChoVayId).then(
      (response) => {
        const tatToanChoDuyet = response?.data?.TatToanChoDuyet;

        if (tatToanChoDuyet != null) {
          setHasTatToanChoDuyet(tatToanChoDuyet);
        }
      },
    );
  };
  const GetTaiKhoanIcloudLienKetByMaHopDong = (MaHopDong) => {
    DanhDachIcloudApi.getTaiKhoanLienKetByMaHopDong(MaHopDong).then(
      (response) => {
        if (response.status === 200) {
          setDataTaiSanIcloudChon(response.data);
        }
      },
    );
  };

  useEffect(() => {
    if (
      !isSetPhiKhac &&
      objListPhiKhac.length > 0 &&
      objListPhiKhac[0].GiaTri !== undefined
    ) {
      setIsSetPhiKhac(true);
      for (let index = 0; index < objListPhiKhac.length; index++) {
        const element = objListPhiKhac[index];
        setValue("ListPhiKhac[" + index + "].GiaTri", element.GiaTri);
        setValue("ListPhiKhac[" + index + "].LoaiPhiKhac", element.LoaiPhiKhac);
        setValue(
          "ListPhiKhac[" + index + "].LoaiPhiKhacChon",
          element.LoaiPhiKhacChon,
        );
      }
    }

    if (choVayEdit.ChoVayId > 0) {
      getLoaiPhiPhat();
    }

    //lay danh sach nhan vien
    UserApi.combo().then((response) => {
      if (response.status === 200) {
        const users = response.data
          .filter((item) => item.value !== "0" && item.value !== "")
          .map((item) => ({
            value: item.value,
            label: item.label,
          }));
        setListNhanVien(users);
      }
    });

    if (
      !isSetPhiKhacHangKy &&
      objListPhiKhacHangKy.length > 0 &&
      objListPhiKhacHangKy[0].GiaTri !== undefined
    ) {
      setIsSetPhiKhacHangKy(true);
      for (let index = 0; index < objListPhiKhacHangKy.length; index++) {
        const element = objListPhiKhacHangKy[index];
        setValue("ListPhiKhacHangKy[" + index + "].GiaTri", element.GiaTri);
        setValue(
          "ListPhiKhacHangKy[" + index + "].LoaiPhiKhacHangKy",
          element.LoaiPhiKhacHangKy,
        );
        setValue(
          "ListPhiKhacHangKy[" + index + "].LoaiPhiKhacHangKyChon",
          element.LoaiPhiKhacHangKyChon,
        );
      }
    }
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onHide(); // Gọi hàm đóng popup
      }
    };

    // Thêm sự kiện lắng nghe khi component được mount
    document.addEventListener("keydown", handleEscape);

    // Dọn dẹp sự kiện khi component unmount
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onHide]);

  useEffect(() => {
    if (!isCauHinhT77 || ChoVayId <= 0 || ChoVayId == undefined) return;
    TaiSanApi.taiSanTheoChoVay({ chovayId: ChoVayId }).then((response) => {
      if ((response.ok || response.status === 200) && response.data) {
        const data = Array.isArray(response.data) ? response.data : [];

        if (data.length > 0) {
          setListTaiSanCamCo(data.slice(1));
          console.log("listTaiSan", data.slice(1));
          if (data.length > 1) {
            setShowAddNewTaiSan(true);
          }
        } else {
          setListTaiSanCamCo([]);
        }
      } else {
        pushNotification(
          "Lỗi. Không lấy được tài sản theo cho vay.",
          "error",
          "TOP_CENTER",
          1000,
        );
      }
    });
  }, [isCauHinhT77, ChoVayId]);

  const kiemTraHopDongChoVayKySo = (ChoVayId) => {
    KySoAPI.kiemTraHopDongChoVayKySo(ChoVayId).then((response) => {
      if (response.data.DaKySo) {
        setHasKySo(response.data.DaKySo);
      }
    });
  };

  const onChangeAttNumberChoVay = (field) => (evt) => {
    var value = convertToNumber(evt.target.value); //evt.target.value.replace(",","")
    choVayEdit[field] = value;
    setValue(field, value);
    if (field === "Sotienvay") {
      choVayEdit.ValueHoaHong = (convertToNumber(evt.target.value) * 1.2) / 100;
      setValue("ValueHoaHong", choVayEdit.ValueHoaHong);
    }
    setChoVayEdit(choVayEdit);
  };

  const onChangeValueSoTienLai = (field, value) => {
    console.log("value", value);
    choVayEdit[field] = value;
    setChoVayEdit(choVayEdit);
  };

  const onChangeAttTextChoVay = (field) => (evt) => {
    choVayEdit[field] = evt.target.value;
    setValue(field, evt.target.value);
    setChoVayEdit(choVayEdit);
  };
  const onChangeTypePaid = () => (evt) => {
    if (evt.target.checked) {
      choVayEdit.TypePaid = 2;
    } else {
      choVayEdit.TypePaid = 1;
    }
    setChoVayEdit(choVayEdit);
  };
  const onChangeStatusPaidHo = () => (evt) => {
    choVayEdit.StatusPaidHo = parseInt(evt.target.value);
    setChoVayEdit(choVayEdit);
  };

  const onChangeTypeDuNo = () => (evt) => {
    choVayEdit.TypeDuNo = parseInt(evt.target.value, 10);
    setChoVayEdit(choVayEdit);
  };

  //Chọn kỳ của Thời gian vay (Ngày/Tuần/Tháng định kỳ/Tháng) - dùng cho Dư nợ gốc bằng nhau của isMoney88
  const onChangeTypePaidTraGop = () => (evt) => {
    choVayEdit.TypePaid = parseInt(evt.target.value, 10);
    setValue("TypePaid", choVayEdit.TypePaid);
    setChoVayEdit({ ...choVayEdit });
  };

  const onChangeBeforeAfterDuNoGoc = () => (evt) => {
    choVayEdit.BeforeAfter = parseInt(evt.target.value, 10);
    setChoVayEdit({ ...choVayEdit });
  };

  const onChangeKieuLaiSuatDuNoGoc = () => (evt) => {
    choVayEdit.KieuLaiSuat = parseInt(evt.target.value, 10);
    setChoVayEdit({ ...choVayEdit });
  };

  //Dư nợ gốc bằng nhau (isMoney88): hợp đồng mới mặc định kỳ Tháng định kỳ
  const daSetKyMacDinhDuNoGoc = useRef(false);
  useEffect(() => {
    const laDuNoGocBangNhau =
      isMoney88 && isDuNoGiamDan && selectedTypeDuNo === 2;
    if (!laDuNoGocBangNhau || ChoVayId > 0) {
      //Rời Dư nợ gốc bằng nhau khi đang thêm mới: trả BeforeAfter về mặc định của trả góp thường,
      //tránh "Thu lãi trước" vừa chọn lọt sang ô BeforeAfter (có thể ẩn) của LaiPhang
      if (daSetKyMacDinhDuNoGoc.current && !(ChoVayId > 0) && ConfigTMTG) {
        choVayEdit.BeforeAfter = ConfigTMTG._beforeAfterTraGop === 0 ? 1 : 2;
        choVayEdit.KieuLaiSuat = undefined;
        setChoVayEdit({ ...choVayEdit });
      }
      daSetKyMacDinhDuNoGoc.current = false;
      return;
    }
    if (!daSetKyMacDinhDuNoGoc.current) {
      daSetKyMacDinhDuNoGoc.current = true;
      choVayEdit.TypePaid = choVayConst.TypePaid.ThangDinhKy;
      setValue("TypePaid", choVayConst.TypePaid.ThangDinhKy);
      if (!choVayEdit.CountTypePaid || choVayEdit.CountTypePaid <= 0) {
        choVayEdit.CountTypePaid = "1";
        setValue("CountTypePaid", "1");
      }
      //Không theo cấu hình _beforeAfterTraGop của trả góp thường: mặc định giữ thu lãi sau như luồng cũ
      choVayEdit.BeforeAfter = 1;
      choVayEdit.KieuLaiSuat = choVayConst.KieuLaiSuat.LaiPhanTramDinhKy;
      setChoVayEdit({ ...choVayEdit });
    }
  }, [isMoney88, isDuNoGiamDan, selectedTypeDuNo, ChoVayId]);

  let { PhanQuyenTraGop } = phanquyen;
  let {
    chonngaygiaodich,
    laiho_sudungchoduyet,
    ChoPhepSuaMaHopDong,
    SuDungMaNhanVien,
  } = PhanQuyenTraGop;

  const onChangDuNoGiamDan = (evt) => {
    const isChecked = evt.target.checked;
    setIsDuNoGiamDan(isChecked);
    choVayEdit.IsDuNoGiamDan = isChecked;
    if (isChecked) {
      choVayEdit.NgayThanhToan = choVayEdit.NgayVay;
    }
    setChoVayEdit(choVayEdit);
  };

  const onSubmit = (dataChoVay) => {
    if (isCauHinhT77 && (!TenTaiSan || !TenTaiSan.trim())) {
      pushNotification(
        "Vui lòng nhập tên tài sản",
        "error",
        "TOP_CENTER",
        1000,
      );
      return;
    }

    dataChoVay.ImageList = imageTaiSans.map(function (elem) {
      if (typeof elem.url !== "undefined") {
        return elem.url;
      } else {
        return elem;
      }
    });
    if (dataChoVay.StatusPaidHo == undefined || dataChoVay.StatusPaidHo == 0)
      dataChoVay.StatusPaidHo = choVayEdit.StatusPaidHo;

    if (isCauHinhT77) {
      if (!dataChoVay.ListHangTheChap) {
        dataChoVay.ListHangTheChap = [{}];
      }
      if (!dataChoVay.ListHangTheChap[0]) {
        dataChoVay.ListHangTheChap[0] = {};
      }
      dataChoVay.ListHangTheChap[0].CategoryId = CategoryId;
      dataChoVay.ListHangTheChap[0].TenTaiSan = TenTaiSan;
      if (
        LoaiTaiSan !== null &&
        typeof LoaiTaiSan !== "undefined" &&
        LoaiTaiSan !== ""
      ) {
        dataChoVay.ListHangTheChap[0].LoaiTaiSan = LoaiTaiSan;
      } else if (
        !dataChoVay.ListHangTheChap[0].LoaiTaiSan &&
        ListLoaiTaiSan.length > 0
      ) {
        dataChoVay.ListHangTheChap[0].LoaiTaiSan = ListLoaiTaiSan[0].value;
      }
      dataChoVay.ListHangTheChap[0].StoreID = StoreID;
      dataChoVay.ListHangTheChap[0].Code = MaTaiSan;
      dataChoVay.ListHangTheChap[0].PhiKho = PhiKho;
      if (!dataChoVay.ListHangTheChap[0].ThuocTinhTaiSan) {
        dataChoVay.ListHangTheChap[0].ThuocTinhTaiSan = ThuocTinhTaiSan;
      }
      dataChoVay.ListHangTheChap[0].Note = NoteTaiSan;
      dataChoVay.ListHangTheChap[0].AnhTaiSan = imageTaiSans
        .map(function (elem) {
          if (typeof elem.url !== "undefined") {
            return elem.url;
          } else {
            return elem;
          }
        })
        .join(";");
      let listTSpost = ListTaiSanCamCo.slice();
      listTSpost.unshift(dataChoVay.ListHangTheChap[0]);
      dataChoVay.ListHangTheChap = listTSpost;
    }
    dataChoVay.TypeDuNo = selectedTypeDuNo;
    dataChoVay.TypePaid = choVayEdit.TypePaid;
    if (isMoney88 && isDuNoGiamDan && selectedTypeDuNo === 2) {
      dataChoVay.BeforeAfter = Number(choVayEdit.BeforeAfter) === 2 ? 2 : 1;
      dataChoVay.KieuLaiSuat = layKieuLaiSuatDuNoGoc(
        choVayEdit.TypePaid,
        choVayEdit.KieuLaiSuat,
      );
    }
    dataChoVay.IsDuNoGiamDan = isDuNoGiamDan;
    dataChoVay.MaNhanVien = choVayEdit.MaNhanVien;
    dataChoVay.FileDinhKems = fileDinhKems
      .map(function (elem) {
        if (typeof elem.url !== "undefined") {
          return elem.url;
        } else {
          return elem;
        }
      })
      .join(";");

    if (choVayEdit.IsCopy) dataChoVay.Code = "";
    if (
      typeof choVayEdit.ImgCusNewSave != "undefined" &&
      choVayEdit.imgCusOld === dataChoVay.customer.Img
    ) {
      dataChoVay.customer.Img = choVayEdit.ImgCusNewSave;
    } else {
      choVayEdit.imgCusOld = dataChoVay.customer.Img;
    }
    //Giá trị có thể là number (khi set mặc định) hoặc string có dấu phẩy (từ NumberFormat)
    if (dataChoVay.BocTrongVong != undefined)
      dataChoVay.BocTrongVong = String(dataChoVay.BocTrongVong).replace(
        ",",
        "",
      );
    if (dataChoVay.CountTypePaid != undefined)
      dataChoVay.CountTypePaid = String(dataChoVay.CountTypePaid).replace(
        ",",
        "",
      );

    dataChoVay.Phantram = choVayEdit.Phantram;
    dataChoVay.LoaiPhiPhatTraLai = choVayEdit.LoaiPhiPhatTraLai;
    dataChoVay.LoaiPhiPhatTatToan = choVayEdit.LoaiPhiPhatTatToan;
    //Không gửi khi chưa có giá trị (cờ tắt, hoặc nguồn mở form không trả cột này):
    //backend gặp null sẽ giữ nguyên giá trị đã lưu
    if (SuDungPhiPhat_DongLai_Cham && choVayEdit.PhiDongLaiCham != null)
      dataChoVay.PhiDongLaiCham = convertToNumber(choVayEdit.PhiDongLaiCham);
    else delete dataChoVay.PhiDongLaiCham;
    if (isCauHinhTaiKhoanIcloud == true) {
      if (dataChoVay.customer.NguonKhId == 0) {
        pushNotification(
          "Vui lòng chọn nguồn khách hàng",
          "error",
          "TOP_CENTER",
          1000,
        );
        return;
      }
      if (dataChoVay.customer.TaiKhoanIcloudId == 0) {
        pushNotification(
          "Vui lòng chọn tài khoản Icloud",
          "error",
          "TOP_CENTER",
          1000,
        );
        return;
      }
      if (dataChoVay.customer.SoHDLienKet > 4) {
        if (window.confirm("Vượt quá số lượng hợp đồng liên kết với ICL?")) {
        } else {
          return;
        }
      }
    }

    if (isCauHinhQuyTrinhPheDuyet && !isShopadmin) {
      let sotienvaydc = parseFloat(
        formatMoney(dataChoVay.Sotienvay).replaceAll(",", ""),
      );
      if (tragop_duyettheolichsuvay && laiho_sudungchoduyet != true) {
        if (
          dataChoVay.customer.DebtLevel == "50" ||
          dataChoVay.customer.DebtLevel == "40" ||
          dataChoVay.customer.DebtLevel == "30" ||
          dataChoVay.customer.DebtLevel == "20"
        ) {
          if (
            window.confirm(
              "Khách hàng đang thuộc tình trạng nợ xấu. Hợp đồng sẽ chuyển chờ duyệt?",
            )
          ) {
            laiho_sudungchoduyet = true;
          } else {
            return;
          }
        }
      }
      // if (tinchap_duyettheohanmucgoi && laingay_sudungchoduyet != true) {
      //   if (sotienvaydc > GiaGoiVay) {
      //     if (window.confirm("Tổng tiền vay đang lớn hơn giới hạn cho vay theo gói. Hợp đồng sẽ chuyển chờ duyệt?")) {
      //       laingay_sudungchoduyet = true;
      //     } else {
      //       return;
      //     }
      //   }
      // }
      if (tragop_duyettheohanmucchophep && laiho_sudungchoduyet != true) {
        if (sotienvaydc > thamDinhHanMuc) {
          if (
            window.confirm(
              "Tổng tiền vay đang lớn hơn giới hạn cho vay cho phép. Hợp đồng sẽ chuyển chờ duyệt?",
            )
          ) {
            laiho_sudungchoduyet = true;
          } else {
            return;
          }
        }
      }
    }
    dataChoVay.HinhThucThanhToan = batHinhThucThanhToan
      ? parseInt(hinhThucThanhToan, 10)
      : null;
    postTraGop({
      ChoVay: dataChoVay,
      Customer: dataChoVay.customer,
      IsChoDuyet: laiho_sudungchoduyet,
      IsCopy: choVayEdit.IsCopy ? choVayEdit.IsCopy : false,
    });
  };
  const onChangeNgayVay = (evt) => {
    choVayEdit.NgayVay = evt;
    if (IsDuNoGiamDan !== undefined) {
      if (_anDinhNgayThangTraGop) {
        if (_IsMacDinh1ThangAnDinhTraGop) {
          choVayEdit.NgayThanhToan = convertDate(
            addOneMonthKeepDay1(choVayEdit.NgayVay),
          );
        } else {
          choVayEdit.NgayThanhToan = evt;
        }
      }
    }
    setChoVayEdit(choVayEdit);
  };
  const onChangeNgayThanhToan = (evt) => {
    choVayEdit.NgayThanhToan = evt;
    setChoVayEdit(choVayEdit);
  };

  const onChangePhiKhac = (configId) => (evt) => {
    if (evt.target.value != undefined) {
      objListPhiKhac[configId].GiaTri = evt.target.value;
      if (setListPhiKhac != undefined) setListPhiKhac(objListPhiKhac);
    }
  };

  const onChangeLoaiPhiKhac = (configId, val) => (evt) => {
    objListPhiKhac[configId].LoaiPhiKhacChon = val;
    if (setListPhiKhac != undefined) setListPhiKhac(objListPhiKhac);
    setChonLoaiPhiKhac(!ChonLoaiPhiKhac);
  };

  const onChangePhiKhacHangKy = (configId) => (evt) => {
    objListPhiKhacHangKy[configId].GiaTri = evt.value;
  };

  const onChangeLoaiPhiKhacHangKy = (configId, val) => (evt) => {
    objListPhiKhacHangKy[configId].LoaiPhiKhacHangKyChon = val;
    setChonLoaiPhiKhacHangKy(!ChonLoaiPhiKhacHangKy);
  };

  const onChangeLoaiPhiPhatTraLai = (val) => (evt) => {
    setLoaiPhiPhatTraLai(val);
    choVayEdit.LoaiPhiPhatTraLai = val;
    setChoVayEdit(choVayEdit);
  };

  const onChangeLoaiPhiPhatTatToan = (val) => (evt) => {
    setLoaiPhiPhatTatToan(val);
    choVayEdit.LoaiPhiPhatTatToan = val;
    setChoVayEdit(choVayEdit);
  };

  const getLoaiPhiPhat = () => {
    TraGopApi.getPhiPhatByChoVayId(choVayEdit.ChoVayId).then((response) => {
      if (response && response.data && response.data.IsSuccess) {
        const phiChamDongLai = response.data.ChamDongLai?.GiaTri ?? 0;
        choVayEdit["PhiPhatTraLai"] = phiChamDongLai;
        setValue("PhiPhatTraLai", phiChamDongLai);

        const phiTatToanSom = response.data.TatToanSom?.GiaTri ?? 0;
        choVayEdit["PhiPhatTatToan"] = phiTatToanSom;
        setValue("PhiPhatTatToan", phiTatToanSom);

        setLoaiPhiPhatTraLai(response.data.ChamDongLai?.LoaiPhiPhat);

        choVayEdit.LoaiPhiPhatTraLai = response.data.ChamDongLai?.LoaiPhiPhat;

        setLoaiPhiPhatTatToan(response.data.TatToanSom?.LoaiPhiPhat);

        choVayEdit.LoaiPhiPhatTatToan = response.data.TatToanSom?.LoaiPhiPhat;

        setChoVayEdit(choVayEdit);
      }
    });
  };

  const closeThemMoi = () => () => {
    setIsDisable(false);
    getDetailCustomerSuccess({});
    onHide();
  };
  if (postTraGopReturn) {
    setIsDisable(true);
    // onHide();
    setIsTraGopReturn();
    setImageTaiSans(choVayEdit.lstImgTaiSanSave.split(";"));
    setFileDinhKems(choVayEdit.ImgDinhKemSave.split(";"));
  }
  let { autocompleteData } = customer;
  let { combo } = user;
  let showLaiPhang = !isDuNoGiamDan;
  let showDuNoGiamDan = isDuNoGiamDan;
  return (
    <>
      <Modal
        show={show}
        size="modal-new-size modal-new-size"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
      >
        <div
          className={
            "loader loader-default " + (postTraGopLoading ? "is-active" : "")
          }
        ></div>
        <form
          className="form tat-toan form-horizontal form-edit"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Modal.Header>
            <h4 className="modal-title  color7-bold" id="myModalLabel16">
              <span className="btn-icon-right">
                <img src="/app-assets/images/icon-them-moi-hop-dong-v2.png" />
              </span>{" "}
              {ChoVayId > 0 ? "Cập nhật" : "Thêm mới"} hợp đồng
            </h4>
            <button
              type="button"
              className="close-popup-new"
              data-dismiss="modal"
              aria-label="Close"
              onClick={closeThemMoi()}
            >
              <img src="/app-assets/images/icon-dong-popup-v2.png" />
            </button>
          </Modal.Header>
          <Modal.Body
            style={{ padding: "0px", background: "#F4F5FA !important" }}
          >
            <div className="form tat-toan form-horizontal form-edit thoimoihopdong">
              <div className="form-body">
                <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                  {HasTatToanChoDuyet === 1 && (
                    <>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="thongbaotattoan">
                            {HasTatToanChoDuyet === 1 && (
                              <>
                                <i
                                  className="mdi mdi-alert"
                                  style={{ color: "#d39c00" }}
                                ></i>{" "}
                                HỢP ĐỒNG ĐANG CHỜ DUYỆT YÊU CẦU TẤT TOÁN
                              </>
                            )}

                            {HasKySo === 1 && (
                              <>
                                {HasTatToanChoDuyet === 1 && <br />}
                                HỢP ĐỒNG ĐÃ ĐƯỢC KÝ SỐ
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  <div
                    id="headingCollapse196"
                    className="card-header"
                    data-toggle="collapse"
                    href="#collapse196"
                    aria-expanded="true"
                    aria-controls="collapse196"
                  >
                    <a
                      className="card-title lead info collapsed"
                      href={() => false}
                    >
                      <h3>Thông tin khách vay</h3>
                    </a>
                  </div>
                  <div
                    id="collapse196"
                    aria-labelledby="headingCollapse96"
                    className="card-collapse collapse show"
                    aria-expanded="true"
                  >
                    <CustomerForm
                      customerId={CustomerID}
                      currentForm={currentForm}
                      autocompleteData={autocompleteData}
                      getAutocompleteCustomer={getAutocompleteCustomer}
                      userCombo={combo}
                      comboNguonKhachHang={comboNguonKhachHang}
                      customer={customer}
                      getDetailCustomer={getDetailCustomer}
                      errors={errors}
                      IsEditCustomer={IsEditCustomer}
                      checkEditCustomer={checkEditCustomer}
                      setEnableEditCustomer={setEnableEditCustomer}
                      IsCopy={IsCopy}
                      CodeCuaHang={thongTinCuaHang.Code}
                      isCauHinhTaiKhoanIcloud={isCauHinhTaiKhoanIcloud}
                      dataTaiSanIcloudChon={dataTaiSanIcloudChon}
                    ></CustomerForm>
                  </div>
                </div>
              </div>
            </div>
            <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
              <div
                id="headingCollapse194"
                className="card-header mt-1"
                data-toggle="collapse"
                href="#collapse194"
                aria-expanded="true"
                aria-controls="collapse194"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Thông tin cho vay</h3>
                </a>
              </div>
              <div
                id="collapse194"
                aria-labelledby="headingCollapse94"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="row">
                      <input
                        type="hidden"
                        name="ChoVayId"
                        value={ChoVayId}
                        ref={register}
                      ></input>{" "}
                      <ThuocTinhThongKeHopDong
                        currentForm={currentForm}
                        choVayId={choVayEdit.ChoVayId}
                        khoa={IsEditChoVay}
                      />
                      <div className="col-md-12 col-lg-12">
                        {ConfigTMTG &&
                          ConfigTMTG._duNoGiamDanTraGop === true && (
                            <>
                              <div
                                className="row"
                                style={{ marginBottom: "10px" }}
                              >
                                <div className="col-md-4">
                                  <input
                                    type="checkbox"
                                    id="chkDuNoGiamDanTraGop"
                                    onChange={onChangDuNoGiamDan}
                                    checked={isDuNoGiamDan}
                                    disabled={choVayEdit.ChoVayId > 0}
                                  />
                                  <label
                                    className="color7-bold"
                                    for="chkDuNoGiamDanTraGop"
                                  >
                                    &nbsp;Sử dụng dư nợ giảm dần
                                  </label>
                                </div>
                                {isDuNoGocCoDinh && isDuNoGiamDan && (
                                  <div className="col-md-4">
                                    <label class="color7-bold">
                                      Loại giảm dần
                                    </label>
                                    <select
                                      ref={register}
                                      className="form-control input-sm"
                                      onChange={onChangeTypeDuNo()}
                                      value={selectedTypeDuNo}
                                      defaultValue={selectedTypeDuNo}
                                      disabled={
                                        IsEditChoVay || !_allTraThieuTraDuTraGop
                                      }
                                      name="TypeDuNo"
                                    >
                                      <option value="1">
                                        {isMoney88
                                          ? "Dư nợ trả góp"
                                          : "Trả đều (Tổng cố định)"}
                                      </option>
                                      <option value="2">
                                        {isMoney88
                                          ? "Dư nợ gốc bằng nhau"
                                          : "Gốc cố định - Lãi giảm dần"}
                                      </option>
                                    </select>
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                        {isCauHinhT77 && (
                          <div className="row">
                            <div className="col-md-4">
                              <label className="label-control color7-bold">
                                Tên tài sản{" "}
                                <span className="canh-bao-red">*</span>
                              </label>
                              <fieldset>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    name="ListHangTheChap[0].TenTaiSan"
                                    value={TenTaiSan}
                                    className="form-control input-sm"
                                    onChange={setAttTaiSan("TenTaiSan")}
                                    disabled={IsEditChoVay}
                                    ref={register({
                                      required: "Vui lòng nhập tên tài sản",
                                    })}
                                  ></input>
                                </div>
                              </fieldset>
                              <span className="canh-bao-red">
                                {errors.ListHangTheChap &&
                                  errors.ListHangTheChap[0] &&
                                  errors.ListHangTheChap[0].TenTaiSan &&
                                  errors.ListHangTheChap[0].TenTaiSan.message}
                              </span>
                            </div>

                            <div className="col-md-4">
                              <label className="label-control color7-bold">
                                Loại tài sản{" "}
                                <span className="canh-bao-red">*</span>
                              </label>
                              <br />
                              <select
                                name="ListHangTheChap[0].LoaiTaiSan"
                                className="form-control input-sm col-md-12  select-v2"
                                ref={register}
                                value={LoaiTaiSan}
                                onChange={onChangeLoaiTaiSan}
                                defaultValue={LoaiTaiSan}
                                disabled={IsEditChoVay}
                              >
                                {ListLoaiTaiSan &&
                                  ListLoaiTaiSan.map((item, idx) => (
                                    <option
                                      key={"comboLoaiTaiSan" + idx}
                                      value={item.value}
                                    >
                                      {item.label}
                                    </option>
                                  ))}
                              </select>
                            </div>
                            <div className="col-md-4">
                              <label className="label-control color7-bold">
                                &nbsp;
                              </label>
                              <br />
                              <div>
                                <button
                                  type="button"
                                  className="btn-them-moi-ts"
                                  onClick={() => showModalLoaiTaiSan(true)}
                                  style={{ margin: "0px" }}
                                >
                                  <i className="mdi mdi-plus"></i>{" "}
                                  <span
                                    style={{
                                      fontSize: "15px",
                                    }}
                                  >
                                    Thêm mới loại tài sản
                                  </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="row thongtinchovay-v2">
                          {showLaiPhang && (
                            <LaiPhang
                              func={{
                                onChangeNgayVay: onChangeNgayVay,
                                onChangeAttNumberChoVay:
                                  onChangeAttNumberChoVay,
                                onChangeTypePaid: onChangeTypePaid,
                                onChangeAttTextChoVay: onChangeAttTextChoVay,
                                onChangeStatusPaidHo: onChangeStatusPaidHo,
                                onChangeNgayThanhToan: onChangeNgayThanhToan,
                                onChangeValueSoTienLai: onChangeValueSoTienLai,
                              }}
                              data={choVayEdit}
                              register={register}
                              chonngaygiaodich={chonngaygiaodich}
                              IsEditChoVay={IsEditChoVay}
                              control={control}
                              errors={errors}
                              config={ConfigTMTG}
                              ChoPhepSuaMaHopDong={ChoPhepSuaMaHopDong}
                              IsCopy={IsCopy}
                              isCauHinhKhachHangBinhAn={
                                isCauHinhKhachHangBinhAn
                              }
                            ></LaiPhang>
                          )}
                          {showDuNoGiamDan && (
                            <DuNoGiamDan
                              func={{
                                onChangeNgayVay: onChangeNgayVay,
                                onChangeAttNumberChoVay:
                                  onChangeAttNumberChoVay,
                                onChangeTypePaid: onChangeTypePaid,
                                onChangeTypePaidTraGop: onChangeTypePaidTraGop,
                                onChangeBeforeAfterDuNoGoc:
                                  onChangeBeforeAfterDuNoGoc,
                                onChangeKieuLaiSuatDuNoGoc:
                                  onChangeKieuLaiSuatDuNoGoc,
                                onChangeAttTextChoVay: onChangeAttTextChoVay,
                                onChangeStatusPaidHo: onChangeStatusPaidHo,
                                onChangeNgayThanhToan: onChangeNgayThanhToan,
                              }}
                              data={choVayEdit}
                              register={register}
                              chonngaygiaodich={chonngaygiaodich}
                              IsEditChoVay={IsEditChoVay}
                              control={control}
                              errors={errors}
                              config={ConfigTMTG}
                              SuDungPhiPhat_DongLai_TatToan={
                                SuDungPhiPhat_DongLai_TatToan
                              }
                              ChoPhepSuaMaHopDong={ChoPhepSuaMaHopDong}
                              isCauHinhKhachHangBinhAn={
                                isCauHinhKhachHangBinhAn
                              }
                              isCauHinhT77={isCauHinhT77}
                              TypeDuNo={selectedTypeDuNo}
                              isMoney88={isMoney88}
                              chiPhiVayTheoNgay={chiPhiVayTheoNgayHienThi}
                            ></DuNoGiamDan>
                          )}
                          {cauHinhThuKyDau === true && (
                            <div className="col-md-4">
                              <NumberInput
                                labelClass="col-md-6 label-control"
                                inputClass="form-control input-sm"
                                inputWrapClass="col-md-6"
                                labelText="Số tiền thu kỳ đầu"
                                wrapperClass="form-group row"
                                inputProps={{
                                  name: "SoTienThuKyDau",
                                  value: SoTienThuKyDau,
                                  onChange:
                                    onChangeAttNumberChoVay("SoTienThuKyDau"),
                                  control: control,
                                  readOnly: IsEditChoVay,
                                }}
                              ></NumberInput>
                            </div>
                          )}
                          {SuDungPhiPhat_DongLai_Cham && (
                            <div className="col-md-4">
                              <NumberInput
                                labelClass="col-md-6 label-control"
                                inputClass="form-control input-sm"
                                inputWrapClass="col-md-6"
                                labelText="Phí phạt đóng lãi chậm (%)"
                                wrapperClass="form-group row"
                                inputProps={{
                                  name: "PhiDongLaiCham",
                                  value: PhiDongLaiCham,
                                  onChange:
                                    onChangeAttNumberChoVay("PhiDongLaiCham"),
                                  control: control,
                                  readOnly: IsEditChoVay,
                                }}
                              ></NumberInput>
                            </div>
                          )}
                          {SuDungPhiPhat_DongLai_TatToan && (
                            <>
                              <div className="col-md-12"></div>
                              <div className="col-md-4">
                                <NumberInput
                                  labelClass="col-md-6 label-control"
                                  inputClass="form-control input-sm"
                                  inputWrapClass="col-md-6"
                                  labelText="Phạt chậm đóng lãi"
                                  wrapperClass="form-group row"
                                  inputProps={{
                                    name: "PhiPhatTraLai",
                                    value: PhiPhatTraLai,
                                    onChange:
                                      onChangeAttNumberChoVay("PhiPhatTraLai"),
                                    control: control,
                                    readOnly: IsEditChoVay,
                                  }}
                                ></NumberInput>
                              </div>
                              <div className="col-md-4 radio-button-nhap-tien">
                                <label className="custom-radio">
                                  <input
                                    type="radio"
                                    name="LoaiPhiPhatTraLai"
                                    onChange={onChangeLoaiPhiPhatTraLai(1)}
                                    checked={
                                      intLoaiPhiPhatTraLai === 1 ? true : false
                                    }
                                    disabled={IsEditChoVay}
                                  />{" "}
                                  <span className="radio-mark"></span>
                                  Nhập tiền
                                </label>
                                <label className="custom-radio radio-button-nhap-phan-tram">
                                  <input
                                    type="radio"
                                    name="LoaiPhiPhatTraLai"
                                    onChange={onChangeLoaiPhiPhatTraLai(2)}
                                    checked={
                                      intLoaiPhiPhatTraLai === 2 ? true : false
                                    }
                                    disabled={IsEditChoVay}
                                  />{" "}
                                  <span className="radio-mark"></span>
                                  Nhập %
                                </label>
                              </div>
                              <div className="col-md-4"></div>
                            </>
                          )}
                          {SuDungTatToanSom && (
                            <>
                              <div className="col-md-4">
                                <NumberInput
                                  labelClass="col-md-6 label-control"
                                  inputClass="form-control input-sm"
                                  inputWrapClass="col-md-6"
                                  labelText="Phạt tất toán sớm"
                                  wrapperClass="form-group row"
                                  inputProps={{
                                    name: "PhiPhatTatToan",
                                    value: PhiPhatTatToan,
                                    onChange:
                                      onChangeAttNumberChoVay("PhiPhatTatToan"),
                                    control: control,
                                    readOnly: IsEditChoVay,
                                  }}
                                ></NumberInput>
                              </div>
                              <div className="col-md-4 radio-button-nhap-tien">
                                <label className="custom-radio">
                                  <input
                                    type="radio"
                                    name="LoaiPhiPhatTatToan"
                                    onChange={onChangeLoaiPhiPhatTatToan(1)}
                                    checked={
                                      intLoaiPhiPhatTatToan === 1 ? true : false
                                    }
                                    disabled={IsEditChoVay}
                                  />{" "}
                                  <span className="radio-mark"></span>
                                  Nhập tiền
                                </label>
                                <label className="custom-radio radio-button-nhap-phan-tram">
                                  <input
                                    type="radio"
                                    name="LoaiPhiPhatTatToan"
                                    onChange={onChangeLoaiPhiPhatTatToan(2)}
                                    checked={
                                      intLoaiPhiPhatTatToan === 2 ? true : false
                                    }
                                    disabled={IsEditChoVay}
                                  />{" "}
                                  <span className="radio-mark"></span>
                                  Nhập %
                                </label>
                              </div>
                              <div className="col-md-4"></div>
                            </>
                          )}
                          <div className="col-md-12"></div>
                          {SuDungCongTacVienNhanVien && (
                            <div className="col-md-4">
                              <TextInputTwoRow
                                labelClass="col-md-2 label-control"
                                inputClass="form-control input-sm"
                                inputWrapClass="col-md-4"
                                wrapperClass="form-group row"
                                labelText="Mã nhân viên"
                                placeholder="Mã nhân viên"
                                inputProps={{
                                  name: "MaNhanVien",
                                  onChange: onChangeAttTextChoVay("MaNhanVien"),
                                  value: MaNhanVien,
                                }}
                              ></TextInputTwoRow>
                            </div>
                          )}
                          {SuDungMaNhanVien && listNhanVien.length > 1 && (
                            <div className="col-md-4">
                              <label className=" label-control color7-bold">
                                Nhân viên
                              </label>
                              <div>
                                <select
                                  name="MaNhanVien"
                                  className="form-control input-sm"
                                  ref={register}
                                  value={MaNhanVien}
                                  defaultValue={""}
                                  disabled={IsEditChoVay}
                                  onChange={onChangeAttTextChoVay("MaNhanVien")}
                                >
                                  {listNhanVien.length > 1 && (
                                    <option value="">
                                      -- Chọn nhân viên --
                                    </option>
                                  )}
                                  {listNhanVien &&
                                    listNhanVien.map((nv) => (
                                      <option value={nv.value}>
                                        {nv.label}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                          )}
                          {batHinhThucThanhToan && (
                            <div className="col-md-4">
                              <label className="color7-bold label-control">
                                Hình thức thanh toán
                              </label>

                              <select
                                className="form-control input-sm select-v2"
                                value={hinhThucThanhToan}
                                onChange={(e) =>
                                  setHinhThucThanhToan(e.target.value)
                                }
                                disabled={IsEditChoVay}
                              >
                                <option value="0">Tiền mặt</option>
                                <option value="1">Chuyển khoản</option>
                              </select>
                            </div>
                          )}
                          <div className="col-md-12">
                            <label className="label-control color7-bold">
                              Ghi chú
                            </label>
                            <textarea
                              rows="2"
                              style={{ minHeight: "80px" }}
                              className="textarea-customer input-sm"
                              name="Note"
                              placeholder=""
                              value={Note}
                              onChange={onChangeAttTextChoVay("Note")}
                              ref={register}
                              disabled={IsEditChoVay}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
              <div
                id="headingCollapse9416"
                className="card-header  mt-1"
                data-toggle="collapse"
                href="#collapse19417"
                aria-expanded="false"
                aria-controls="collapse194"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Các loại phí</h3>
                </a>
              </div>
              <div
                id="collapse19417"
                role="tabpanel"
                aria-labelledby="headingCollapse9416"
                className="card-collapse collapse"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12 col-lg-12">
                        {objListPhiKhac &&
                          objListPhiKhac.map((item, idx) => (
                            <div key={"phiKhac" + idx}>
                              <div className="row">
                                <div className="col-md-6">
                                  <NumberInput
                                    labelClass="col-md-6 label-control"
                                    inputClass="form-control input-sm"
                                    inputWrapClass="col-md-6"
                                    wrapperClass="form-group row"
                                    labelText={item.TenPhiKhac}
                                    inputProps={{
                                      name: "ListPhiKhac[" + idx + "].GiaTri",
                                      value: objListPhiKhac[idx].GiaTri,
                                      onChange: onChangePhiKhac(idx),
                                      control: control,
                                      readOnly: IsEditChoVay,
                                    }}
                                  ></NumberInput>
                                </div>
                                <div className="col-md-6">
                                  {item.LoaiPhiKhac == 1 ? (
                                    <>
                                      &nbsp;
                                      <br />
                                      <div className="col-md-12 radio-button-nhap-tien">
                                        <label className="custom-radio">
                                          <input
                                            type="radio"
                                            name={
                                              "ListPhiKhac[" +
                                              idx +
                                              "].LoaiPhiKhac"
                                            }
                                            value="1"
                                            checked={true}
                                            disabled={true}
                                          />{" "}
                                          <span className="radio-mark"></span>
                                          Nhập tiền
                                        </label>
                                        <label
                                          className="custom-radio"
                                          style={{ paddingLeft: "10px" }}
                                        >
                                          <input
                                            type="radio"
                                            name={
                                              "ListPhiKhac[" +
                                              idx +
                                              "].LoaiPhiKhac"
                                            }
                                            value="2"
                                            checked={false}
                                            disabled={true}
                                          />{" "}
                                          <span className="radio-mark"></span>
                                          Nhập %
                                        </label>
                                      </div>
                                    </>
                                  ) : item.LoaiPhiKhac == 2 ? (
                                    <>
                                      &nbsp;
                                      <br />
                                      <div
                                        className="col-md-12"
                                        style={{ paddingTop: "20px" }}
                                      >
                                        <label className="custom-radio">
                                          <input
                                            type="radio"
                                            name={
                                              "ListPhiKhac[" +
                                              idx +
                                              "].LoaiPhiKhac"
                                            }
                                            value="1"
                                            checked={false}
                                            disabled={true}
                                          />{" "}
                                          <span className="radio-mark"></span>
                                          Nhập Tiền
                                        </label>
                                        <label
                                          className="custom-radio"
                                          style={{ paddingLeft: "10px" }}
                                        >
                                          <input
                                            type="radio"
                                            name={
                                              "ListPhiKhac[" +
                                              idx +
                                              "].LoaiPhiKhac"
                                            }
                                            value="2"
                                            checked={true}
                                            disabled={true}
                                          />{" "}
                                          <span className="radio-mark"></span>
                                          Nhập %
                                        </label>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      &nbsp;
                                      <br />
                                      <div className="col-md-12 radio-button-nhap-tien">
                                        <label className="custom-radio">
                                          <input
                                            type="radio"
                                            name={
                                              "ListPhiKhac[" +
                                              idx +
                                              "].LoaiPhiKhacChon"
                                            }
                                            value="1"
                                            checked={
                                              objListPhiKhac[idx]
                                                .LoaiPhiKhacChon === 1
                                                ? true
                                                : false
                                            }
                                            ref={register}
                                            disabled={IsEditChoVay}
                                            onChange={onChangeLoaiPhiKhac(
                                              idx,
                                              1,
                                            )}
                                          />{" "}
                                          <span className="radio-mark"></span>
                                          Nhập tiền
                                        </label>
                                        <label
                                          className="custom-radio"
                                          style={{ paddingLeft: "10px" }}
                                        >
                                          <input
                                            type="radio"
                                            name={
                                              "ListPhiKhac[" +
                                              idx +
                                              "].LoaiPhiKhacChon"
                                            }
                                            value="2"
                                            checked={
                                              objListPhiKhac[idx]
                                                .LoaiPhiKhacChon === 2
                                                ? true
                                                : false
                                            }
                                            ref={register}
                                            disabled={IsEditChoVay}
                                            onChange={onChangeLoaiPhiKhac(
                                              idx,
                                              2,
                                            )}
                                          />{" "}
                                          <span className="radio-mark"></span>
                                          Nhập %
                                        </label>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                              <input
                                type="hidden"
                                name={
                                  "ListPhiKhac[" + idx + "].ConfigPhiKhacId"
                                }
                                value={item.ConfigPhiKhacId}
                                ref={register}
                              />
                              <input
                                type="hidden"
                                name={"ListPhiKhac[" + idx + "].LoaiPhiKhac"}
                                value={item.LoaiPhiKhac}
                                ref={register}
                              />
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
                {objListPhiKhacHangKy != undefined &&
                  objListPhiKhacHangKy.length > 0 && (
                    <>
                      <div
                        id="headingCollapse194121"
                        className="card-header  mt-1"
                        data-toggle="collapse"
                        href="#collapse194121"
                        aria-expanded="false"
                        aria-controls="collapse1941"
                      >
                        <a
                          className="card-title lead info collapsed"
                          href={() => false}
                        >
                          <h3>Các loại phí hàng kỳ</h3>
                        </a>
                      </div>
                      <div
                        id="collapse194121"
                        role="tabpanel"
                        aria-labelledby="headingCollapse194121"
                        className="card-collapse collapse"
                      >
                        <div className="card-content">
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-12 col-lg-12">
                                {objListPhiKhacHangKy &&
                                  objListPhiKhacHangKy.map((item, idx) => (
                                    <div key={"phiKhacHangKy" + idx}>
                                      <div className="row">
                                        <div className="col-md-6">
                                          <NumberInput
                                            labelClass="col-md-6 label-control"
                                            inputClass="form-control input-sm"
                                            inputWrapClass="col-md-6"
                                            wrapperClass="form-group row"
                                            labelText={item.TenPhiKhacHangKy}
                                            inputProps={{
                                              name:
                                                "ListPhiKhacHangKy[" +
                                                idx +
                                                "].GiaTri",
                                              value:
                                                objListPhiKhacHangKy[idx]
                                                  .GiaTri,
                                              onChange:
                                                onChangePhiKhacHangKy(idx),
                                              control: control,
                                              readOnly: IsEditChoVay,
                                            }}
                                          ></NumberInput>
                                        </div>
                                        <div className="col-md-6">
                                          {item.LoaiPhiKhacHangKy == 1 ? (
                                            <>
                                              &nbsp;
                                              <br />
                                              <div
                                                className="col-md-12"
                                                style={{ paddingTop: "20px" }}
                                              >
                                                <label className="custom-radio">
                                                  <input
                                                    type="radio"
                                                    name={
                                                      "ListPhiKhacHangKy[" +
                                                      idx +
                                                      "].LoaiPhiKhacHangKy"
                                                    }
                                                    value="1"
                                                    checked={true}
                                                    disabled={true}
                                                  />
                                                  <span className="radio-mark"></span>
                                                  Nhập tiền
                                                </label>

                                                <label
                                                  className="custom-radio"
                                                  style={{
                                                    paddingLeft: "10px",
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    name={
                                                      "ListPhiKhacHangKy[" +
                                                      idx +
                                                      "].LoaiPhiKhacHangKy"
                                                    }
                                                    value="2"
                                                    checked={false}
                                                    disabled={true}
                                                  />
                                                  <span className="radio-mark"></span>
                                                  Nhập %
                                                </label>
                                              </div>
                                            </>
                                          ) : item.LoaiPhiKhacHangKy == 2 ? (
                                            <>
                                              &nbsp;
                                              <br />
                                              <div className="col-md-12 radio-button-nhap-tien">
                                                <label className="custom-radio">
                                                  <input
                                                    type="radio"
                                                    name={
                                                      "ListPhiKhacHangKy[" +
                                                      idx +
                                                      "].LoaiPhiKhacHangKy"
                                                    }
                                                    value="1"
                                                    checked={false}
                                                    disabled={true}
                                                  />
                                                  <span className="radio-mark"></span>
                                                  Nhập tiền
                                                </label>
                                                <label
                                                  className="custom-radio"
                                                  style={{
                                                    paddingLeft: "10px",
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    name={
                                                      "ListPhiKhacHangKy[" +
                                                      idx +
                                                      "].LoaiPhiKhacHangKy"
                                                    }
                                                    value="2"
                                                    checked={true}
                                                    disabled={true}
                                                  />
                                                  <span className="radio-mark"></span>
                                                  Nhập %
                                                </label>
                                              </div>
                                            </>
                                          ) : (
                                            <>
                                              &nbsp;
                                              <br />
                                              <div className="col-md-12 radio-button-nhap-tien">
                                                <label className="custom-radio">
                                                  <input
                                                    type="radio"
                                                    name={
                                                      "ListPhiKhacHangKy[" +
                                                      idx +
                                                      "].LoaiPhiKhacHangKyChon"
                                                    }
                                                    value="1"
                                                    checked={
                                                      objListPhiKhacHangKy[idx]
                                                        .LoaiPhiKhacHangKyChon ===
                                                      1
                                                        ? true
                                                        : false
                                                    }
                                                    ref={register}
                                                    disabled={IsEditChoVay}
                                                    onChange={onChangeLoaiPhiKhacHangKy(
                                                      idx,
                                                      1,
                                                    )}
                                                  />
                                                  <span className="radio-mark"></span>
                                                  Nhập tiền
                                                </label>

                                                <label
                                                  className="custom-radio"
                                                  style={{
                                                    paddingLeft: "10px",
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    name={
                                                      "ListPhiKhacHangKy[" +
                                                      idx +
                                                      "].LoaiPhiKhacHangKyChon"
                                                    }
                                                    value="2"
                                                    checked={
                                                      objListPhiKhacHangKy[idx]
                                                        .LoaiPhiKhacHangKyChon ===
                                                      2
                                                        ? true
                                                        : false
                                                    }
                                                    ref={register}
                                                    disabled={IsEditChoVay}
                                                    onChange={onChangeLoaiPhiKhacHangKy(
                                                      idx,
                                                      2,
                                                    )}
                                                  />
                                                  <span className="radio-mark"></span>
                                                  Nhập %
                                                </label>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                      <input
                                        type="hidden"
                                        name={
                                          "ListPhiKhacHangKy[" +
                                          idx +
                                          "].ConfigPhiKhacHangKyId"
                                        }
                                        value={item.ConfigPhiKhacHangKyId}
                                        ref={register}
                                      />
                                      <input
                                        type="hidden"
                                        name={
                                          "ListPhiKhacHangKy[" +
                                          idx +
                                          "].LoaiPhiKhacHangKy"
                                        }
                                        value={item.LoaiPhiKhacHangKy}
                                        ref={register}
                                      />
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
              </div>
            </div>
            {!isCauHinhT77 && (
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div
                  id="headingCollapse19412"
                  className="card-header  mt-1"
                  data-toggle="collapse"
                  href="#collapse19413"
                  aria-expanded="false"
                  aria-controls="collapse19413"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Bổ sung giấy tờ tín chấp vay</h3>
                  </a>
                </div>
                <div
                  id="collapse19413"
                  role="tabpanel"
                  aria-labelledby="headingCollapse9412"
                  className="card-collapse collapse"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <label class="col-md-4 color7-bold">
                          Giấy tờ tín chấp
                        </label>
                        <br />
                        <div className="col-md-12">
                          <input
                            type="text"
                            className="form-control input-sm"
                            placeholder="1 CMT + 1 GPLX"
                            name="NoteTaiSan"
                            ref={register}
                            readOnly={IsEditChoVay}
                          />
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12">
                          <UploadMultiFile
                            Files={imageTaiSans}
                            onChange={setImageTaiSans}
                            Code={thongTinCuaHang.Code}
                          ></UploadMultiFile>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {isCauHinhT77 && (
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div
                  id="headingCollapse191"
                  className="card-header  mt-1"
                  data-toggle="collapse"
                  href="#collapse191"
                  aria-expanded="false"
                  aria-controls="collapse191"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Thông tin tài sản</h3>
                  </a>
                </div>
                <div
                  id="collapse191"
                  role="tabpanel"
                  aria-labelledby="headingCollapse191"
                  className="card-collapse collapse"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <input
                            type="hidden"
                            name="ListHangTheChap[0].CategoryId"
                            value={CategoryId || ""}
                            ref={register}
                          ></input>
                          <div className="row">
                            {ThuocTinhTaiSan &&
                              ThuocTinhTaiSan.map((item, index) => (
                                <div
                                  className="col-md-3"
                                  key={"Thuoctinhts1" + index}
                                >
                                  <TextInputOnRow
                                    labelClass="label-control color7-bold"
                                    inputClass="form-control input-sm"
                                    wrapperClass="form-group"
                                    labelText={item.TenThuocTinh}
                                    inputProps={{
                                      ref: register,
                                      name:
                                        "ListHangTheChap[0].ThuocTinhTaiSan[" +
                                        index +
                                        "].OptionValue",
                                      onChange: onChangeThuocTinhTaiSan(index),
                                      value: ThuocTinhTaiSan[index].OptionValue,
                                    }}
                                  ></TextInputOnRow>
                                  <input
                                    type="hidden"
                                    name={
                                      "ListHangTheChap[0].ThuocTinhTaiSan[" +
                                      index +
                                      "].OptionName"
                                    }
                                    value={item.MaThuocTinh}
                                    ref={register}
                                  ></input>
                                </div>
                              ))}

                            <div className="col-md-3">
                              <div className="form-group">
                                <label className="label-control color7-bold">
                                  Kho
                                </label>
                                <select
                                  name="ListHangTheChap[0].StoreID"
                                  className="selectBox form-control input-sm select-v2"
                                  ref={register}
                                  value={StoreID || ""}
                                  onChange={setAttTaiSan("StoreID")}
                                >
                                  {objComboStore &&
                                    objComboStore.map((item, idx) => (
                                      <option
                                        key={"objComboStore1" + idx}
                                        value={item.value}
                                      >
                                        {item.label}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <TextInputOnRow
                                labelClass="label-control color7-bold"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Mã tài sản"
                                inputProps={{
                                  ref: register,
                                  name: "ListHangTheChap[0].Code",
                                  onChange: setAttTaiSan("MaTaiSan"),
                                  value: MaTaiSan || "",
                                }}
                              ></TextInputOnRow>
                            </div>
                            {ConfigPhiKho === 1 && (
                              <div className={"col-md-3 "}>
                                <div className="form-group">
                                  <label className="label-control color7-bold">
                                    Phí kho/ngày
                                  </label>
                                  <NumberFormat
                                    thousandSeparator={true}
                                    prefix={""}
                                    inputMode="numeric"
                                    className="form-control input-sm"
                                    placeholder="%"
                                    name="ListHangTheChap[0].PhiKho"
                                    onChange={setAttTaiSan("PhiKho")}
                                    value={PhiKho || ""}
                                    getInputRef={register}
                                  />
                                </div>
                              </div>
                            )}

                            <div
                              className="col-md-12"
                              style={{ marginTop: "10px" }}
                            >
                              <div className="form-group">
                                <label className="label-control color7-bold">
                                  Ghi chú
                                </label>
                                <textarea
                                  rows="1"
                                  style={{ minHeight: "80px" }}
                                  className="form-control input-sm text-era"
                                  name="ListHangTheChap[0].Note"
                                  placeholder="Ghi chu"
                                  ref={register}
                                  onChange={setAttTaiSan("Note")}
                                  value={NoteTaiSan || ""}
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 mt-1">
                          <div className="row">
                            <div className="col-md-12">
                              <UploadMultiFile
                                Files={imageTaiSans}
                                onChange={setImageTaiSans}
                                Code={thongTinCuaHang.Code}
                              ></UploadMultiFile>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group overflow-hidden form-actions text-right">
                      <button
                        type="button"
                        className="btn-them-moi-ts"
                        onClick={() => onClickShowAddNewTaiSan(true)}
                        style={{ margin: "0px" }}
                      >
                        <i className="mdi mdi-plus"></i>{" "}
                        <span style={{ fontSize: "15px" }}>
                          Thêm mới tài sản khác
                        </span>
                      </button>
                    </div>
                    <div className={showAddNewTaiSan ? "" : "hidden"}>
                      <ListTaiSanForm
                        comboLoaiTaiSan={ListLoaiTaiSan}
                        getThuocTinhTaiSan1={getThuocTinhTaiSan1}
                        loadThuocTinhTaiSan={getThuocTinhTaiSan}
                        listTaiSan={ListTaiSanCamCo}
                        onChange={onChangeListTaiSan}
                        thuoctinhtaisan={thuoctinhtaisan}
                        thuocTinhTaiSanData={objThuocTinhTaiSan}
                        thuocTinhTaiSanLoaded={thuocTinhTaiSanLoaded}
                        objComboStore={objComboStore}
                        cauHinhPhiKho={PhiKho}
                        codeCuaHang={thongTinCuaHang.Code}
                      ></ListTaiSanForm>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
              <div
                id="headingCollapse191191"
                className="card-header  mt-1"
                data-toggle="collapse"
                href="#collapse191191"
                aria-expanded="false"
                aria-controls="collapse194"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Đính kèm file</h3>
                </a>
              </div>
              <div
                id="collapse191191"
                role="tabpanel"
                aria-labelledby="headingCollapse9412"
                className="card-collapse collapse"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12 col-lg-12">
                        <UploadMultiFile1
                          Files={fileDinhKems}
                          onChange={setFileDinhKems}
                          Code={thongTinCuaHang.Code}
                        ></UploadMultiFile1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="modal-footer button-popup-new-size">
            <button
              type="button"
              class="btn btn-new-main btn-closenew"
              href={() => false}
              onClick={closeThemMoi()}
            >
              <span>
                <i class="mdi mdi-close"></i>
              </span>
              &nbsp; Đóng &nbsp;
            </button>
            {CanhBaoSoHopDong != "" && (
              <span style={{ color: "red" }}>{CanhBaoSoHopDong}</span>
            )}
            {isDisable !== true && HasTatToanChoDuyet !== 1 && (
              <button className="btn btn-new-main btn-checknew" type="submit">
                <span className="btn-icon-left">&nbsp;</span>{" "}
                {laiho_sudungchoduyet ? "Chờ duyệt" : "Lưu lại"}
              </button>
            )}
            {showButtonIn &&
              (isCauHinhQuyTrinhPheDuyet == false ||
                laiho_sudungchoduyet == false ||
                (laiho_sudungchoduyet == true &&
                  tragop_inchoduyet == true)) && (
                <button
                  className="btn btn-new-main btn-checknew"
                  href={() => false}
                  onClick={inHopDong(choVayEdit)}
                  type="button"
                >
                  <span className="btn-icon-left">
                    <i className="mdi mdi-printer"></i>
                  </span>{" "}
                  In hợp đồng
                </button>
              )}

            {showButtonInPhieuThu && (
              <button
                className="btn btn-new-main btn-checknew"
                href={() => false}
                onClick={inPhieuThu(ThuChiId)}
                type="button"
              >
                <span className="btn-icon-left">
                  <i className="mdi mdi-printer"></i>
                </span>{" "}
                In phiếu thu
              </button>
            )}
          </Modal.Footer>
        </form>
      </Modal>
      {isShowModalLoaiTaiSan && (
        <ThemMoiLoaiTaiSanContainer
          show={isShowModalLoaiTaiSan}
          onHide={hideModalLoaiTaiSan}
        ></ThemMoiLoaiTaiSanContainer>
      )}
    </>
  );
};
export default ThemMoiTraGop;
